var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("badge\n    flex\n    justify-center\n    items-center\n    text-center\n    shape-" + _vm.shape + "\n    absolute\n    position-" + _vm.position),style:({
    color: _vm.textColor,
    backgroundColor: _vm.backgroundColor,
    borderColor: _vm.borderColor
  })},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }